'use strict'
/**
 * src/contracts — Fuente única de verdad de los contratos entre capas.
 * MACRO 1 · Catarsis 1 · "La frontera que no miente".
 *
 * Productores (engine/API) y consumidores (UI) importan DEL MISMO módulo.
 * Validación en la frontera vía validateContract() — fail-loud, nunca
 * fallback silencioso (doctrina 15/16).
 *
 * Ola 1 (las 3 cicatrices): DomainContext · WorkoutAnalysis · AriaContext
 * Ola 2: PrimeScore · DayPlan · LandedReading · USV-v0 · TodayResponse
 */

const { validateContract, setContractReporter, reportContractViolation } = require('./validate')
const surfaceState = require('./surfaceState')

const { FenotypicContextSchema, RankedDomainSchema, ExploreResponseSchema } = require('./domainContext')
const { WorkoutHeaderSchema, GlanceSchema, WorkoutAnalysisSchema, LatestAnalysisResponseSchema } = require('./workoutAnalysis')
const { AriaContextSchema } = require('./ariaContext')
const { PrimeScoreSchema } = require('./primeScore')
const { DayPlanSchema } = require('./dayPlan')
const { LandedReadingSchema, LandedReadingFullSchema, LandedReadingErrorSchema, LandedReadingDisabledSchema } = require('./landedReading')
const { UsvV0Schema, TriggerType } = require('./usv')
const { TodayResponseSchema } = require('./todayResponse')
const { Balance360AxisSchema, DomainDeltaSchema, ProgressPartesSchema, PARTES_ORDER, PARTES_COUNT, PARTES_SECONDARY } = require('./progressSummary')
const { SeamCoherenceSchema, validateSessionTypeTemplateCohesion, SESSION_FAMILIES, TEMPLATE_TYPE_FAMILY } = require('./sessionTypeTemplate')
// FICHA:D6 · la Ficha del 10 (las 12 piezas del §1) servida por GET /api/ficha/:userId
const { FuenteSchema, PiezaFichaSchema, MotivoFichaSchema, FichaDelDiezSchema, FichaResponseSchema } = require('./fichaDelDiez')

module.exports = {
  // Mecánica
  validateContract,
  setContractReporter,
  reportContractViolation,
  surfaceState,
  // Ola 1 — cicatrices
  FenotypicContextSchema,
  RankedDomainSchema,
  ExploreResponseSchema,
  WorkoutHeaderSchema,
  GlanceSchema,
  WorkoutAnalysisSchema,
  LatestAnalysisResponseSchema,
  AriaContextSchema,
  // Ola 2
  PrimeScoreSchema,
  DayPlanSchema,
  LandedReadingSchema,
  LandedReadingFullSchema,
  LandedReadingErrorSchema,
  LandedReadingDisabledSchema,
  UsvV0Schema,
  TriggerType,
  TodayResponseSchema,
  // OPERACIÓN PIEL · F2 — superficie "Tus partes"
  Balance360AxisSchema,
  DomainDeltaSchema,
  ProgressPartesSchema,
  PARTES_ORDER,
  PARTES_COUNT,
  PARTES_SECONDARY,
  // MINI-MACRO F3-FIX · costura sessionType ↔ template
  SeamCoherenceSchema,
  validateSessionTypeTemplateCohesion,
  SESSION_FAMILIES,
  TEMPLATE_TYPE_FAMILY,
  // FICHA:D6 — la Ficha del 10
  FuenteSchema,
  PiezaFichaSchema,
  MotivoFichaSchema,
  FichaDelDiezSchema,
  FichaResponseSchema,
}
